import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "./App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "./Card";
import SchafkopfGameSelect from "./GameSelect";
import PointsOverview from "./PointsOverview";

function Game() {
  let { gameId, playerId } = useParams();
  const [hand, setHand] = useState([]);
  const [stich, setStich] = useState([]);
  const [lastStich, setLastStich] = useState([]);
  const [wonStiche, setWonStiche] = useState([]); // Won stiche (tricks) for the player
  const [currentPlayer, setCurrentPlayer] = useState(""); // Won stiche (tricks) for the player
  const [players, setPlayers] = useState([]); // Won stiche (tricks) for the player
  const [gameChoice, setGameChoice] = useState({}); // this is the current game choice that needs to be displayed
  const [finalGameChoice, setFinalGameChoice] = useState(""); // Won stiche (tricks) for the player
  const [finalPlayerChoice, setFinalPlayerChoice] = useState(""); // Won stiche (tricks) for the player
  const [selectedGame, setSelectedGame] = useState(""); // Won stiche (tricks) for the player
  const [data, setData] = useState({}); // Won stiche (tricks) for the player
  const [pointsData, setPointsData] = useState({}); // Won stiche (tricks) for the player

  const [winner, setWinner] = useState(""); // Won stiche (tricks) for the player
  const [cardToSwap, setCardToSwap] = useState("");



  const [message, setMessage] = useState(""); // Track if the initial fetch has happened
  const navigate = useNavigate();

  const [isPaused, setPause] = useState(false);
  const ws = useRef(null);

  useEffect(() => {
    ws.current = new WebSocket(
      `${API_URL.replace("http", "ws")}/ws/game/${gameId}/${playerId}`
    );

    ws.current.onopen = () => console.log("ws opened");
    ws.current.onclose = () => {
      console.log("ws closed");
      ws.current = new WebSocket(
        `${API_URL.replace("http", "ws")}/ws/game/${gameId}/${playerId}`
      );
    };

    const interval = setInterval(() => {
      if (ws.current.readyState === WebSocket.OPEN) {
        sendMessage({ type: "ping" });
      }
    }, 20000); // 20 seconds
  }, []);

  // Initialize or reuse the WebSocket connection
  useEffect(() => {
    if (!ws.current) return;

    ws.current.onopen = () => {
      console.log("WebSocket connected");
      setMessage("");
    };

    ws.current.onmessage = (event) => {
      if (isPaused) return;
      const data = JSON.parse(event.data);

      switch (data.type) {
        case "game_state":
          setHand(data.hands[playerId] || []);
          setStich(data.stich);
          setCurrentPlayer(data.current_player);
          setPlayers(data.players);

          if (finalGameChoice !== data.final_game_choice["game"]){
            if (data.final_game_choice["game"] === "Ruf-Eichel") {
              playAudio("eichel-ass-johnny");
            }
            if (data.final_game_choice["game"] === "Wenz") {
              playAudio("wenz-bernd");
            }
          }

          setFinalGameChoice(data.final_game_choice["game"]);

          setFinalPlayerChoice(data.final_game_choice["player_id"]);
          setGameChoice(data.game_choice);
          if (data.alle_stiche.length > 0)
            setLastStich(data.alle_stiche[data.alle_stiche.length - 1]);

          if (data.stich.length === 4) {
            decideStich();
          }

          if (
            data.won_stiche &&
            data.won_stiche[playerId] &&
            data.stiche_punkte
          ) {
            setWonStiche(data.won_stiche[playerId]);
          } else {
            setWonStiche([]);
          }

          setData(data);

          break;
        case "error":
          setMessage(data.message);
          break;
        case "winner":
          setWinner(data.winnerId);
          resetWinner();
          break;
        case "point_stats":
          setPointsData(data);

          break;
        case "redirect":
          navigate(`/`);
          ws.current.close(); // Close WebSocket before navigating
          break;
        case "ping":
          break;
        default:
          console.warn("Unknown WebSocket message type:", data.type);
      }
    };

    ws.current.onerror = (error) => {
      console.error("WebSocket error:", error);
      setMessage("WebSocket connection error.");
    };

    ws.current.onclose = () => {
      console.log("ws closed");
      ws.current = new WebSocket(
        `${API_URL.replace("http", "ws")}/ws/game/${gameId}/${playerId}`
      );
    };
  }, [isPaused, gameId, playerId, finalGameChoice, data]);

  const playAudio = (filename) => {
    const audio = new Audio(`/sounds/${filename}.wav`); // Pfad zur .wav-Datei
    audio
      .play()
      .then(() => {
        console.log("Audio abgespielt.");
      })
      .catch((error) => {
        console.error("Fehler beim Abspielen der Audio-Datei:", error);
      });
  };

  // Send a message via WebSocket
  const sendMessage = (message) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(message));
    } else {
      setMessage("WebSocket is not connected.");
    }
  };

  const returnCard = async (card) => {
    sendMessage({ type: "return_card", card });
  };

  // Play a card
  const playCard = async (card) => {
    if (selectedGame === "Hochzeit" && !cardToSwap) {
      setCardToSwap(card);
      setMessage(`Du hast ${card} für die Hochzeit gewählt.`);
      // Now send it since we have both game + card
      sendMessage({ type: "set_game_choice", selectedGame: "Hochzeit", cardToSwap: card });
      return;
    }

    // Regular play
    if (data.final_game_choice?.game === "Hochzeit" && !data.final_game_choice.accepter) {
      setCardToSwap(card);
      return;
    }

    sendMessage({ type: "play_card", playerId, card });
  };

  const decideStich = async () => {
    await new Promise((resolve) => setTimeout(resolve, 2000));

    sendMessage({ type: "stich_nehmen" });
  };

  const chooseGame = async (selectedGame) => {
    console.log(selectedGame);
    console.log(cardToSwap);
    setSelectedGame(selectedGame);
    if (selectedGame === "Hochzeit") {
      setMessage("Bitte wähle eine Karte für die Hochzeit!");
      return;
    }

    if (selectedGame === "Hochzeit"){
      sendMessage({ type: "set_game_choice", selectedGame, cardToSwap });
    }
    else {
      sendMessage({ type: "set_game_choice", selectedGame });
    }
  };

  const chooseWantToPlay = async (wantsToPlay) => {
    console.log(wantsToPlay);
    sendMessage({ type: "set_wants_to_play", wantsToPlay });
  };

  const schiessen = async () => {
    sendMessage({ type: "schiessen" });
  };

  const reject_hochzeit = async() => {
      sendMessage({type: "reject_hochzeit"});
  };
  const accept_hochzeit = async() => {
    console.log(cardToSwap)
    console.log(playerId)
      sendMessage({ type: "accept_hochzeit", playerId, cardToSwap });
  };

  // Reset the game state
  const restartGame = async () => {
    sendMessage({ type: "restart_game" });

    // Clear local state
    setHand([]);
    setStich([]);
    setLastStich([]);
    setWonStiche([]);
  };

  const getPointsData = async () => {
    sendMessage({ type: "getPointsData" });
  };

  useEffect(() => {
    if (hand.length <= 0 && stich.length <= 0) {
      getPointsData()
    }
  }, [hand, stich]);


  useEffect(() => {
    if (message !== "") {
      const timer = setTimeout(() => {
        setMessage("");
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [message]);

  const hashCode = function (s) {
    var h = 0,
      l = s.length,
      i = 0;
    if (l > 0) while (i < l) h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
    return h;
  };

  const resetWinner = () => {
    setTimeout(() => setWinner(null), 2000);
  };

  return (
    <div id="game">
      <div class="header">
        <h2>Schafkopf</h2>
      </div>

      {message && (
        <div class="error">
          <div className={"red"}>
            <FontAwesomeIcon icon="fa-solid fa-circle-xmark" />
            <p>{message}</p>
          </div>
        </div>
      )}

      <div className={"flex-wrap"} class="players">
        {players.map((player, index) => (
          <div key={index} className={"large_text"}>
            <div
              className={
                player === currentPlayer && stich.length < 4 ? "green bold" : ""
              }
            >
              <img
                className={
                  player === currentPlayer && stich.length < 4 ? "active" : ""
                }
                src={`/profile/${Math.abs(hashCode(player) % 20)}.png`}
              />
              {player}
              {hand.length <= 0 && stich.length <= 0 && data.player && (
                <span
                  className={
                    data.player.includes(player) ? "punkte" : "punkte_alt"
                  }
                >
                  {data.stiche_punkte[player]}
                </span>
              )}
            </div>
          </div>
        ))}

        {!finalGameChoice && data.round === 0 && currentPlayer === playerId && (
          <div class="willstdu">
            <b>Willst du spielen?</b>
            <button class="accept" onClick={() => chooseWantToPlay(true)}>
              <FontAwesomeIcon icon="fa-solid fa-check" />
              Ich täterät.
            </button>
            <button class="decline" onClick={() => chooseWantToPlay(false)}>
              <FontAwesomeIcon icon="fa-solid fa-xmark" />
              Ich tät ned.
            </button>
          </div>
        )}

        {finalGameChoice &&
          data.round === 1 &&
          stich.length <= 0 &&
          ((data.non_player.includes(playerId) &&
              data.game_multiplier === 1 ) ||
            (data.player.includes(playerId) &&
              data.game_multiplier === 2 )) && (
            <div class="willstdu">
              <button class="accept" onClick={() => schiessen()}>
                <FontAwesomeIcon icon="fa-solid fa-check" />
                Schuss!
              </button>
            </div>
          )}

        {data.game_multiplier > 1 && (<span><FontAwesomeIcon icon="fa-solid fa-xmark" /> {data.game_multiplier}</span>)}


      </div>
      {!finalGameChoice &&
        data.round !== 0 &&
        data.wants_to_play &&
        data.wants_to_play[playerId] &&
        currentPlayer === playerId && (
          <SchafkopfGameSelect
            chooseGame={chooseGame}
            cardToSwap={cardToSwap}
          />
        )}
      {finalGameChoice && (
        <div class="aktuellesspiel">
          <span>
            <b>
              {finalPlayerChoice} spielt {finalGameChoice}!
            </b>
          </span>
        </div>
      )}

      <h2>Stiche</h2>

      { data && data.kreuz_counter >= 0 && finalGameChoice === 'Kreuz' && (
        <>Kreuzrunde: {4 - data.kreuz_counter} / 4</>
      )
      }

      {winner != null && winner?.length > 0 && (
        <div class="success">
          <div className="green">
            <p>{winner} gewinnt den Stich!</p>
          </div>
        </div>
      )}



      {finalGameChoice && finalGameChoice === "Auflage" && data.round >= 2 && finalPlayerChoice !== playerId && (
        <div
          style={{
            transform: "scale(0.4)", // Scale the card down to 50%
            transformOrigin: "top center", // Ensure the scaling happens from the top-left
            display: "inline-block",
          }}
        >
          <div style={{ display: "flex", gap: "10px", "flex-wrap": "wrap" }}>
            {data.hands[finalPlayerChoice].map((card, index) => (
              <div key={index}>
                <Card key={index} cardName={card} isTrump={card in data.trump_cards}/>
              </div>
            ))}
          </div>
        </div>
      )}


      {data.recommendation && (
        <div>Spielvorschlag: {data.recommendation[playerId]}</div>
      )}

      {data.final_game_choice && data.final_game_choice["game"] === "Hochzeit" && !data.final_game_choice["accepter"] && playerId === currentPlayer && (
          <>
              <button onClick={reject_hochzeit}>Hochzeit ablehnen</button>
              <button onClick={accept_hochzeit} disabled={!cardToSwap || data.final_game_choice?.player_id === playerId}>Hochzeit annehmen</button>
          </>
      )}

      <div class="smash" className={"smallCards smash"}>
        <div className={"flex-wrap"}>
          {stich.map((entry, index) => (
            <div key={index}>
              <Card key={index} cardName={entry.card} isTrump={entry.card in data.trump_cards} />
              <div style={{"text-align": "center"}}>(played by {entry.player})</div>
            </div>
          ))}
        </div>
      </div>

       {pointsData && hand.length <= 0 && stich.length <= 0 && (
        <PointsOverview pointsData={pointsData} finalGameChoice={finalGameChoice} gameMultiplier={data.game_multiplier} sendMessage={sendMessage} playerId={playerId} waitingForPlayers={data.waiting_for_players}>
        </PointsOverview>
      )}

      <div
        style={{
          transform: "scale(0.7)", // Scale the card down to 50%
          transformOrigin: "top center", // Ensure the scaling happens from the top-left
          display: "inline-block", // Avoid layout shifting
        }}
      >
        <div class="handcards" style={{  }}>
          {hand.map((card, index) => (
            <div key={index} onClick={() => playCard(card)}>
              <Card key={index} cardName={card} isTrump={card in data.trump_cards} highlight={cardToSwap === card}/>
            </div>
          ))}
        </div>
      </div>

      {!finalGameChoice && data.round <= 2 && data.wants_to_play && (
        <div class="chat">
          {Object.keys(data.wants_to_play).map((entry, index) => (
            <div class="chatbubble">
              <img
                className={`active`}
                src={`/profile/${Math.abs(hashCode(entry) % 20)}.png`}
              />
              <div>
                <b class="orange">{entry}:</b>{" "}
                {data.wants_to_play[entry] ? "Ich täterät." : "Ich tät ned."}
                <b>{gameChoice[entry]}</b>
              </div>
            </div>
          ))}
        </div>
      )}

      <div class="schublade">
        <details>
          <summary>
            <b>Gewonnene Stiche</b>
          </summary>
          {hand.length > 0 && (
            <div className={"smallCards"}>
              {lastStich.length > 0 ? (
                <>
                  <div className={"flex-wrap"}>
                    {lastStich.map((entry, index) => (
                      <div key={index}>
                        <Card key={index} cardName={entry.card} isTrump={entry.card in data.trump_cards}/>
                        <p>(played by {entry.player})</p>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <p>Keine gewonnene Stiche bisher</p>
              )}
            </div>
          )}
          {hand.length <= 0 && stich.length <= 0 && data.player && (
            <>
              <div>
                {wonStiche.length > 0 ? (
                  <>
                    <ul>
                      {wonStiche.map((stich, index) => (
                        <li key={index}>
                          {stich.map((card) => card.card).join(", ")}
                        </li>
                      ))}
                    </ul>
                    <div className={"bold"}>
                      Gesamtpunkte: {data.stiche_punkte[playerId]}{" "}
                    </div>
                  </>
                ) : (
                  <p>Keine gewonnen Stiche</p>
                )}
              </div>
              <div className={"bold"}>
                Dein Team (
                {data.player.includes(playerId)
                  ? data.player.join(", ")
                  : data.non_player.join(", ")}
                ) hat:{" "}
                {data.player.includes(playerId)
                  ? data.player.reduce(
                      (sum, player) => sum + data.stiche_punkte[player],
                      0
                    )
                  : data.non_player.reduce(
                      (sum, player) => sum + data.stiche_punkte[player],
                      0
                    )}{" "}
                Punkte
              </div>
            </>
          )}
        </details>
      </div>
    </div>
  );
}

export default Game;
